import { env } from '@/config/env';
import { TeamType } from '@/types/domain.types';

export const TeamIcon = (team: TeamType) => {
  return (
    <img
      alt={`${team.name_en}-logo`}
      src={`https://${env.STORAGERESOURCENAME}.blob.core.windows.net/${env.STORAGE_CONTAINER}/${team.team_feed_id}.png`}
      style={{
        width: '32px',
        maxHeight: '32px',
        objectFit: 'contain',
      }}
      onError={(e) => {
        e.currentTarget.style.opacity = '0';
      }}
    />
  );
};
